import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { OpinionsWidget } from "../../components/OpinionsWidget/OpinionsWidget";
import { AttitudeGeoChart } from "../../components/AttitudeGeoChart/AttitudeGeoChart";
import { AttitudeColumnChart } from "../../components/AttitudeColumnChart/AttitudeColumnChart";
import { CountriesAttitudeDistribution } from '../../components/CoutriesAttitudeDistribution/CountriesAttitudeDistribution';
import { useTranslation } from "react-i18next";

import styles from './NarrativePage.module.scss';

export const AmazonDistribution = ({narrative}) => {
  const { t } = useTranslation();

  let caseDescription = narrative?.description || 'There is no description';
  const newText = caseDescription?.replace(/\n+(\s*\n+)?/g, '\n').split('\n');
  const sanitizedText = newText?.map(item => DOMPurify.sanitize(item, { ALLOWED_TAGS: ['mark', 'span'],  ALLOWED_ATTR: ['class']}));

  const clean = useMemo(
    // () => DOMPurify.sanitize(newText, { ALLOWED_TAGS: ['mark'] }),
    () => {
      return sanitizedText;
    },
    [sanitizedText],
  );

  return (
    <div className="list-content">
      <div className="report-section">
        <h3>{t('Description')}</h3>
        <div className={styles.descriptionCard}>
          {clean.map((item, i) => (
            <p
              key={`paragraph_${i}`}
              dangerouslySetInnerHTML={{ __html: item }}
            ></p>
          ))}
        </div>
      </div>

      <div className="report-section">
        <h3>{t('Attitude types')}</h3>
        <AttitudeColumnChart
          report={narrative}
        />
      </div>

      <div className="report-section">
        <h3>{t('Geo Distribution')}</h3>
        <AttitudeGeoChart
          report={narrative}
        />
      </div>
      
      <div className="report-section">
        <OpinionsWidget
          report={narrative}
          showCountries={true}
        />
      </div>

      <CountriesAttitudeDistribution/>
    </div>
  )
}
